import React, { useState, useEffect } from 'react';
import { Avatar, Box, Button, CardContent, Stack, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Alert from '@mui/material/Alert';
import { api } from 'src/Api';

export default function ImageGuidelineModal({ handleClose, product, refreshAdmin }) {
  const [loading, setloading] = useState(false);
  const [alert, setalert] = useState({ visible: false, message: '' });
  const [description, setdescription] = useState('');
  const [file, setfile] = useState({ image: null });

  const [bannerurl, setbannerurl] = useState('');
  function SaveImage() {
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formdata = new FormData();

    product && formdata.append('id', product?.id);
    description && formdata.append('description', description);
    file.file && formdata.append('image_url', file?.file);

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formdata,
      redirect: 'follow'
    };
    setloading(true);

    fetch(product ? api.edit_image_guidelines : api.add_image_guidelines, requestOptions)
      .then((response) => {
        if (response.status === 201 || response.status === 200) {
          return response.text();
        } else {
          return response.json().then((result) => {
            setalert({ visible: true, message: result.error });
          });
        }
      })
      .then((result) => {
        const response = JSON.parse(result);
        refreshAdmin();
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => setloading(false));
  }
  const [objAfter, setobjAfter] = useState({
    name: product?.name,
    file: false
  });

  useEffect(() => {
    if (product) {
      setdescription(product?.description);
      setfile({ image: product?.uri });
    }
  }, [product]);

  return (
    <Box
      p={1}
      mt={2}
      style={{
        width: '100%',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Typography variant="h4" style={{ fontWeight: 'bold', textAlign: 'center' }}>
        {product ? 'Edit Image Guideline' : 'Image Guidleline'}
      </Typography>

      <CardContent
        style={{
          flex: 1,
          width: '95%'
        }}
      >
        <Stack
          mb={2}
          direction={{ xs: 'column' }}
          style={{
            display: 'flex',
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'center'
          }}
          className="image_center"
        >
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '100%'
            }}
          >
            {file?.image ? (
              <img
                alt="image"
                src={objAfter?.file ? file?.image : file?.image}
                style={{
                  borderWidth: 1,
                  width: 100,
                  height: 100,
                  objectFit: 'cover',
                  borderRadius: 4,
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
                }}
              />
            ) : (
              <Box
                style={{
                  width: '100%',
                  height: 150,
                  backgroundColor: '#f0f0f0',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 4,
                  border: '2px dashed #ccc',
                  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
                }}
              >
                <Typography variant="h6" color="textSecondary">
                  Add Image
                </Typography>
              </Box>
            )}
            <Button
              style={{
                width: 150,
                height: 40,
                borderRadius: 20,
                marginTop: 20,
                fontSize: 14
              }}
              variant="outlined"
              component="label"
            >
              {file?.image ? `Change Image` : `Add Image`}
              <input
                type="file"
                hidden
                accept="image/*"
                onChange={(e) => {
                  setobjAfter({ file: true });
                  setfile({
                    image: URL.createObjectURL(e.target.files[0]),
                    file: e.target.files[0]
                  });
                }}
              />
            </Button>
          </Box>
        </Stack>
      </CardContent>
      <Box display={'flex'} sx={{ width: '90%', mt: 0, mb: 2, flexDirection: 'column' }}>
        <TextField
          id="outlined-error-helper-text"
          fullWidth
          label="Description"
          value={description}
          onChange={(val) => {
            setdescription(val.target.value);
          }}
          type="text"
          variant="outlined"
          display="inline"
          multiline={true}
        />
        <Box mb={2} />
        {alert && alert.visible && <Alert severity="error">{alert.message}</Alert>}
      </Box>

      <Box
        p={2}
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '90%'
        }}
      >
        <LoadingButton
          disabled={false}
          loading={loading}
          sx={{
            marginRight: 1
          }}
          onClick={SaveImage}
          color="primary"
          variant="contained"
        >
          Save
        </LoadingButton>
        <LoadingButton onClick={handleClose} variant="outlined">
          Close
        </LoadingButton>
      </Box>
    </Box>
  );
}
